module.exports = __webpack_public_path__ + "img/tire.f363fa6.png";